import { render, staticRenderFns } from "./SystemProjectList.vue?vue&type=template&id=abb307d6&lang=pug&"
import script from "./SystemProjectList.vue?vue&type=script&lang=js&"
export * from "./SystemProjectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports